import React from "react";
import { SECTION } from "../../constant/global";

export default function Navbar({ navAktiv, setNavAktiv }) {
  return (
    <nav className="navbar">
      <ul className="navbar-list">
        {SECTION?.map((x, i) => (
          <li className="navbar-item" key={x}>
            <button
              className={`navbar-link ${i === navAktiv && "active"}`}
              data-nav-link
              onClick={() => setNavAktiv(i)}
            >
              {x}
            </button>
          </li>
        ))}
      </ul>
    </nav>
  );
}
